import React, { useState, SyntheticEvent } from 'react';
import './ReportForm.css';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { PerfilTypesToken } from '../../Types/PerfilTypes';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, InputLabel, FormControl, Box } from '@mui/material';
import { connect } from 'react-redux';

function mapStateToProps (state: any) {
  return { action: state };
}

type ReportUserFormProps = {
  userId?: string;
} & PerfilTypesToken;

function ReportUserForm (props: ReportUserFormProps) {
  const id = props.userId || useParams().id;
  console.log(id);
  const [reason, setReason] = useState<number>(0);
  const [other, setOther] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (showForm) {
      setShowForm(false);
    } else {
      setAnchorEl(event.currentTarget);
      setMenuOpen(true);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleReportClick = () => {
    setShowForm(true);
    handleClose();
  };

  function reportUser (event: SyntheticEvent) {
    event.preventDefault();
    const token = JSON.parse(localStorage.getItem('token') || '');
    const createdById = props.action.user.credenciales.id;

    const reportReasons = {
      1: 'SPAM',
      2: 'INAPROPRIATE',
      3: 'OTHER'
    };

    const classification = reportReasons[reason as keyof typeof reportReasons];
    const reportData = {
      createdbyId: createdById,
      reportedId: id,
      classification,
      description,
      reason: classification,
      other: reason === 3 ? other : undefined
    };

    axios.post(process.env.REACT_APP_URL + '/reportUser/report', reportData, { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        console.log(response);
        swal({
          title: 'Reporte enviado',
          text: 'Gracias por reportar.',
          icon: 'success',
          buttons: { Aceptar: true },
          timer: 2000
        });
        setShowForm(false);
        setReason(0);
        setOther('');
        setDescription('');
      })
      .catch((error) => {
        console.log(error.response);
        swal({
          title: 'Error',
          text: String(error.response.data.message),
          icon: 'error',
          buttons: { Aceptar: true },
          timer: 2000
        });
      });
  }

  return (
    <>
    {props.action.user.credenciales.id !== id &&
      <Box className="report-form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', pr: 1 }}>
        <IconButton onClick={handleClick} size="large">
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleClose}
        >
          <MenuItem onClick={handleReportClick}>Denunciar Usuario</MenuItem>
        </Menu>
        <Dialog open={showForm} onClose={() => setShowForm(false)} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 0 }}>
            <span>Reportar Usuario</span>
            <IconButton onClick={() => setShowForm(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <form onSubmit={reportUser}>
            <DialogContent dividers>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <FormControl fullWidth sx={{ mt: 2, maxWidth: 400 }}>
                  <InputLabel id="reason-label">Razón</InputLabel>
                  <Select
                    labelId="reason-label"
                    id="reason"
                    value={reason}
                    label="Razón"
                    onChange={(e) => setReason(Number(e.target.value))}
                    required
                    sx={{ width: '100%' }}
                    MenuProps={{
                      PaperProps: {
                        sx: { maxWidth: 400 }
                      }
                    }}
                  >
                    <MenuItem value={0} disabled>Selecciona una razón</MenuItem>
                    <MenuItem value={1}>El usuario manda spam</MenuItem>
                    <MenuItem value={2}>El usuario sube contenido inapropiado</MenuItem>
                    <MenuItem value={3}>Otro</MenuItem>
                  </Select>
                </FormControl>
                {reason === 3 && (
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Razón"
                    id="otherReason"
                    name="report"
                    value={other}
                    onChange={e => setOther(e.target.value)}
                    required
                    sx={{ maxWidth: 400 }}
                  />
                )}
                <TextField
                  margin="normal"
                  fullWidth
                  multiline
                  minRows={3}
                  label="Descripción detallada"
                  id="description"
                  name="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  required
                  sx={{ maxWidth: 400 }}
                />
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
              <Button onClick={() => setShowForm(false)} sx={{ color: '#888', borderColor: '#888' }} variant="outlined">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" sx={{ backgroundColor: '#00BBC7', '&:hover': { backgroundColor: '#287685' } }}>
                Enviar
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </Box>
    }
    </>
  );
};

export default connect(mapStateToProps)(ReportUserForm);
